// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - ignore type errors
import { IMask } from 'react-imask';

// This fixes issue where numeric inputs show '0' for inputs with no value
// It is because Number('') === '0' and we use it as a mask, so...yea
// This issue is fixed with react-imask v7, but the update is extremely difficult
// (it fixes a few "bugs" that we actually rely on, ex. https://github.com/uNmAnNeR/imaskjs/issues/896)
// If updating to v7, you can remove this workaround and just use Number
// Github reference: https://github.com /uNmAnNeR/imaskjs/issues/432
export class NullableMaskedNumber extends IMask.MaskedNumber {
  override get typedValue() {
    return this.unmaskedValue !== '' ? super.typedValue : '';
  }
  override set typedValue(num) {
    super.typedValue = num;
  }
}

export const numberMask = () => new NullableMaskedNumber({ mask: Number });
